<template>
  <div>

    <div class="body">
      <!-- 搜索 -->
      <div class="search">
        <!-- 开始时间 -->
        <div class="item">
          <el-date-picker v-model="datas.dateStart" type="datetime" :placeholder="$t('message.startDate')"
            default-time="00:00:00" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 结束日期 -->
        <div class="item">
          <el-date-picker v-model="datas.dateEnd" type="datetime" :placeholder="$t('message.dateClosed')"
            default-time="23:59:59" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 搜索 -->
        <div class="item">
          <el-button type="primary" @click="templateList">{{ $t("message.search") }}</el-button>
        </div>
        <div class="add">
          <!-- 群信息拉取 -->
          <el-button type="primary" class="primary" style="margin-right: 24px;" @click="userDialogVisible = true">
            {{ $t("message.groupInformationPull") }}
          </el-button>
          <!-- 群发信息 -->
          <router-link to="/massMessaging" target="_blank" v-if="isAuth(402)">
            <el-button type="success">
              {{ $t("message.massMessaging") }}
            </el-button>
          </router-link>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
          <!-- 收件人 -->
          <el-table-column align="center" :label="$t('message.recipients')" width="200">
            <template slot-scope="scope">
              <span v-if="scope.row.range == 10 || scope.row.range == 20 || scope.row.range == 30">
                {{ scope.row.group_type }}</span>
              <el-button type="text" v-else @click="getNoticePartClientAndAdmin(scope.row)">
                {{ scope.row.group_type }}
              </el-button>
            </template>
          </el-table-column>

          <!-- 内容 -->
          <el-table-column align="center" :label="$t('message.content')" prop="content">
            <template slot-scope="scope">
              <div v-html="scope.row.content" class="content"></div>
            </template>
          </el-table-column>
          <!-- 添加日期 -->
          <el-table-column align="center" :label="$t('message.addDate')" width="200" prop="created_at">
          </el-table-column>
          <!-- 定时发送时间 -->
          <el-table-column align="center" :label="$t('message.timedTransmissionTime')" width="200" prop="send_date">
          </el-table-column>
          <!-- 发送状态 -->
          <el-table-column align="center" :label="$t('message.sendingStatus')" width="200" prop="status">
            <template slot-scope="scope">
              {{ scope.row.status }}
              <div class="num">
                <div class="item">
                  成功:{{ scope.row.success_num }}
                </div>
                <div class="item">
                  失败：{{ scope.row.error_num }}
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')" width="180">
            <template slot-scope="scope">
              <!-- 删除 -->
              <el-button size="mini" type="primary" class="dark" @click="templateDelete(scope.row.id)"
                v-if="scope.row.status == '等待发送'">
                {{ $t("message.delete") }}</el-button>
              <!-- 导出发送详情 -->
              <a :href="baseURL + '/chatWork.downloadSendDetail?id=' + scope.row.id" target="_blank"
                rel="noopener noreferrer" v-else>
                <el-button size="mini" type="success">
                  {{ $t("message.exportSendingDetails") }}
                </el-button>
              </a>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 人员选择 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="userDialogVisible" width="400px" center title="CW群信息抽取">
      <el-select v-model="yData.id" filterable :placeholder="$t('message.salesman')" style="width: 100%;"
        @change="setRealname">
        <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <a :href="baseURL + '/chatWork.groupDataPull?id=' + yData.id + '&realname=' + yData.realname" target="_blank"
          rel="noopener noreferrer">
          <el-button type="primary" @click="userDialogVisible = false">{{ $t("message.ok")
          }}</el-button>
        </a>
      </span>
    </el-dialog>
    <!-- 人员列表 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="600px" center>
      <el-table :data="userData" border :header-cell-style="{ background: '#EDEFF4' }" max-height="500px">
        <!-- 客户ID -->
        <el-table-column prop="id" label="ID" align="center" width="100">
        </el-table-column>
        <!--客户名称-->
        <el-table-column prop="realname" label="客户名称" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import preview from "../announcement/preview";
import { quillEditor } from "vue-quill-editor";
import quillConfig from "@/utlis/quill-config";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    preview,
    quillEditor,
  },

  data() {
    return {
      activeName: 1,
      quillOption: quillConfig,
      editDialogVisible: false,
      dialogVisible: false,
      datas: {
        range: "",
        dateStart: "",
        dateEnd: "",
        pageSize: 999
      },

      tableData: [],
      item: {},
      userData: [],
      editData: {},
      rules: {
        title: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],

      },

      yData: {
        id: '',
        realname: '',
      },
      y: [],
      userDialogVisible: false,
    };
  },
  created() {
    // 同组织各工种账号列表
    this.$api.getAuthWorkGroupAdminSameLevel().then(res => {
      this.y = res.data.y
    })
    this.templateList();
  },
  methods: {

    templateList() {
      this.$api.noticeApi.templateList(this.datas).then((res) => {
        this.tableData = res.data
      });
    },
    //查看
    look(item) {
      this.item = item;
      this.$refs.preview.dialogVisible = true;
    },
    //部分用户列表
    getNoticePartClientAndAdmin(item) {
      this.$api.siteConfiguration.getNoticePartClientAndAdmin({ notice_id: item.id }).then((res) => {
        this.userData = res.data
        this.dialogVisible = true
      });

    },
    //批量删除通知
    templateDelete(id) {
      this.$confirm(
        // 是否确认删除
        this.$t("message.areYouSureToDelete"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.$api.noticeApi.templateDelete({ id }).then(res => {
            this.$message.success(res.msg)
            this.templateList()
          })
        })
        .catch(() => { });
    },
    //编辑
    redact(item) {
      this.editData = JSON.parse(JSON.stringify(item))
      this.editDialogVisible = true
    },
    //寻找业务员名称
    setRealname(e) {
      this.yData.realname = this.y.find(item => item.id == e).realname
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  position: relative;
  flex-wrap: wrap;

  .item {
    width: 240px;
  }

  .add {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.table {
  margin: 20px 0;
}

.content {
  max-height: 100px;
  overflow-y: auto;
}

/deep/.ql-editor {
  height: 300px !important;
}

.num {
  display: flex;
  width: 100%;

  .item {
    flex: 1;
    justify-content: center;
    align-items: center;
    color: #85ce61;

    &:nth-last-child(1) {
      color: red;
    }
  }
}
</style>